import React from "react";
import ReactDOM from "react-dom/client";
import axios from "axios";
import "@/index.css";
import App from "@/App";

// Force ALL API calls to use current domain (fixes CDN cache + custom domain issues)
axios.defaults.baseURL = '';
axios.defaults.withCredentials = true;
axios.interceptors.request.use((config) => {
  // Strip any absolute URL pointing to a different domain — make it relative
  if (config.url && config.url.startsWith('http')) {
    try {
      const url = new URL(config.url);
      // If the URL points to a different origin, rewrite to relative path
      if (url.origin !== window.location.origin) {
        config.url = url.pathname + url.search;
      }
    } catch {
      // Not a valid URL, leave as-is
    }
  }
  return config;
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
